export default __webpack_public_path__ + "static/10-9efae647594dbd398aa80e13e4affb32.jpg";